import React from 'react';
import './eventDetailsSkeleton.css';

/**
 * Skeleton loader component for the event details page.
 * Mimics the layout of the actual content for better perceived performance.
 */
const EventDetailsSkeleton = () => {
  return (
    <div className="ed-skeleton">
      {/* Status bar skeleton (date + location) */}
      <div className="ed-skeleton-status">
        <div className="ed-skeleton-status-item"></div>
        <div className="ed-skeleton-status-item"></div>
      </div>

      {/* Event info grid skeleton */}
      <div className="ed-skeleton-info-grid">
        <div className="ed-skeleton-info-col">
          <div className="ed-skeleton-info-item">
            <div className="ed-skeleton-icon"></div>
            <div className="ed-skeleton-info-content">
              <div className="ed-skeleton-label"></div>
              <div className="ed-skeleton-value"></div>
            </div>
          </div>
          <div className="ed-skeleton-info-item">
            <div className="ed-skeleton-icon"></div>
            <div className="ed-skeleton-info-content">
              <div className="ed-skeleton-label"></div>
              <div className="ed-skeleton-value"></div>
            </div>
          </div>
          <div className="ed-skeleton-info-item">
            <div className="ed-skeleton-icon"></div>
            <div className="ed-skeleton-info-content">
              <div className="ed-skeleton-label"></div>
              <div className="ed-skeleton-value"></div>
            </div>
          </div>
        </div>
        <div className="ed-skeleton-info-col">
          <div className="ed-skeleton-info-item">
            <div className="ed-skeleton-icon"></div>
            <div className="ed-skeleton-info-content">
              <div className="ed-skeleton-label"></div>
              <div className="ed-skeleton-value"></div>
            </div>
          </div>
          <div className="ed-skeleton-info-item">
            <div className="ed-skeleton-icon"></div>
            <div className="ed-skeleton-info-content">
              <div className="ed-skeleton-label"></div>
              <div className="ed-skeleton-value"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Title skeleton */}
      <div className="ed-skeleton-title"></div>

      {/* Description skeleton */}
      <div className="ed-skeleton-description">
        <div className="ed-skeleton-line ed-skeleton-line-full"></div>
        <div className="ed-skeleton-line ed-skeleton-line-full"></div>
        <div className="ed-skeleton-line ed-skeleton-line-90"></div>
        <div className="ed-skeleton-line ed-skeleton-line-full"></div>
        <div className="ed-skeleton-line ed-skeleton-line-70"></div>
      </div>
    </div>
  );
};

export default EventDetailsSkeleton;
